var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.648 97.7367L91.6295 91.5416L97.743 110.646M110.648 97.7367V30.9776M110.648 97.7367L97.743 110.646M97.743 110.646L104.616 123.384M97.743 110.646L64.3376 95.9636L30.9795 110.646M97.743 110.646H30.9795M123.386 104.614L110.648 97.7453L96.309 64.3356L110.648 30.9776M123.386 104.614V24.0956M123.386 104.614L104.616 123.384M110.648 30.9776L123.386 24.0956M110.648 30.9776L97.7387 18.0551H30.9795M110.648 30.9776L91.6295 37.1726L97.743 18.0679M123.386 24.0956L104.616 5.28711M104.616 123.384H24.0975M30.9795 110.646L24.0975 123.384M30.9795 110.646L18.057 97.7367V30.9776L30.9795 18.0551M24.0975 123.384L5.28906 104.614M30.9795 18.0551L64.3376 32.7464L97.7473 18.0636L104.616 5.28711M30.9795 18.0551L24.0932 5.28711M18.0656 97.7367L37.0844 91.5416L30.9752 110.646M5.28906 104.614L18.0656 97.7453L32.3619 64.3356L18.0656 30.9776M5.28906 104.614L5.29336 24.0956L24.0975 5.2914L104.616 5.28711M18.0656 30.9776L5.28906 24.0913M18.0656 30.9776L37.0844 37.1726L30.9752 18.0679M64.3376 33.0383L91.2474 37.5118L95.3774 64.3356L91.2474 91.2024L64.3376 95.6759L37.4279 91.2024L33.3408 64.3356L37.4279 37.5118L64.3376 33.0383Z",
    stroke: "#151542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiant);
export default __webpack_public_path__ + "static/media/radiant.ca49dfd7961cdc11998b118d482b7124.svg";
export { ForwardRef as ReactComponent };